<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            id?: string;
            disabled?: boolean;
            size?: 'small' | 'large' | 'full';
        }>(),
        {
            id: undefined,
            size: 'large',
        }
    );

    const model = defineModel<string | number>();
</script>

<template>
    <select
        :id="id"
        v-model="model"
        :disabled="disabled"
        class="custom-focus max-w-full cursor-pointer disabled:cursor-default bg-white border-1 text-body border-gray-light rounded-sm shadow-md disabled:pointer-events-none disabled:text-gray-light"
        :class="{
            'px-2 py-1.5 pr-8': props.size === 'small',
            'px-3 py-2.25 min-w-64 pr-10': ['large', 'full'].includes(props.size),
            'flex-grow w-full': props.size === 'full',
        }"
    >
        <slot />
    </select>
</template>
